<template>
  <!-- 下拉选择框 -->
  <div class="selectBox-wrapper" :class="{ 'event-none': !canEdit }">
    <div class="title-wrapper">
      <!-- <div class="clear" @click="clearInput" :class="{ hidden: !canEdit || !showClear}">
        {{ clearText }}
      </div> -->
    </div>
    <div class="content-block">
      <div class="region-wrapper" @click="getSelect">
        <div class="region-code">
          {{ chooseName }}
        </div>
        <img
          :src="unfold"
          class="img-wrapper"
          :class="[ { hidden: !canEdit }, rotateImage ? 'rotate-image': 'restore-image' ]">
      </div>
      <!-- <div class="input-wrapper">
        <input
          :placeholder="this.showRemarks ? $t('regionCode') : $t('inputvalue')"
          class="telinput"
          v-model="value"
          @input="onvalueChange" />
        <div
          class="img-wrapper clear-wrapper"
          :class="{ hidden: !showClearImage }"
          @click="clearInput">
          <img :src="clear" class="clearimg" :class="{ hidden: !canEdit || isEmpty }">
        </div>
      </div> -->
    </div>
    <!-- <div class="telephone-remarks" v-show="showRemarks">
      <input
        :placeholder="$t('inputvalue')"
        class="telinput"
        v-model="telephone"
        @input="onSelectChange" />
    </div> -->
  </div>
</template>
<script>
import ActionPicker, { closeMask as closePickerMask } from '@/components/ActionPicker'
import ActionSheet, { closeMask as closeSheetMask } from '@/components/ActionSheet'
import { Chevron_Down_Blue, Clear } from '@/images'

export default {
  name: 'SelectBox',
  props: {
    showClearImage: { // 显示清除图标
      type: Boolean,
      default () {
        return false
      }
    },
    canEdit: { // 是否可编辑
      type: Boolean,
      default () {
        return true
      }
    },
    clearText: {
      type: String,
      default () {
        return '清除'
      }
    },
    menus: { // 地区菜单
      type: Array,
      default () {
        return []
      }
    },
    selectTitle: {
      type: String,
      default: '自定义标题'
    },
    dataSource: { // 初始化数据源
      type: Object,
      default () {
        return {
          id: 0,
          title: '', // title
          regionCode: '', // 地区区号
          value: '', // 电话
          maxRegionCode: 4, // 地区区号字数限制
          maxTelephone: 15, // 电话字数限制
          remarks: '' // 地区为其他时的电话
        }
      }
    }
  },
  data () {
    return {
      unfold: Chevron_Down_Blue,
      clear: Clear,
      showRemarks: false,
      rotateImage: false,
      chooseName: '',
      value: '',
      telephone: '',
      actionTypes: 'ActionPicker'
    }
  },
  computed: {
    isSelectEmpty () { // 国家码是否为空
      return this.chooseName === this.$t('region') || !this.chooseName
    },
    isEmpty () {
      return this.isSelectEmpty
    },
    showClear () {
      return this.value || !this.isSelectEmpty
    }
  },
  watch: {
    dataSource: {
      handler: function handler (newVal) {
        // console.log('datasource')
        // console.log(newVal)
        this.value = newVal.value
        this.chooseName = newVal.name
      },
      deep: true
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.rotateImage = false
      this.value = this.dataSource.value
      this.title = this.dataSource.title
      this.actionTypes = this.dataSource.actionTypes || 'ActionPicker'
      if (this.judgeEmpty(this.value) && this.canEdit) {
        this.value = ''
      }
      if (this.judgeEmpty(this.dataSource.value)) {
        this.chooseName = this.$t('selectText')
      } else {
        this.chooseName = ''
        this.menus.forEach(item => {
          if (item.value === this.dataSource.value) {
            this.chooseName = item.name
          }
        })
      }
    },
    getSelect () {
      this.rotateImage = !this.rotateImage
      if (this.actionTypes === 'ActionSheet') {
        ActionSheet({
          title: this.title ? this.title : 'tag',
          actions: this.menus,
          cancelText: this.$t('cancel')
        }).then(data => {
          this.rotateImage = !this.rotateImage
          const result = {
            ...data,
            id: this.dataSource.id,
            isEmpty: this.isEmpty
          }
          this.chooseName = data.name

          this.$emit('onSelectChange', result)
        })
          .catch((data) => {
            this.rotateImage = !this.rotateImage
          })
      } else {
        // console.log(this.menus.indexOf(this.dataSource))
        // console.log(this.menus)
        // console.log(this.dataSource)
        ActionPicker({
          id: this.dataSource.id,
          confirmText: this.$t('complete'),
          titleText: this.selectTitle,
          cancelText: this.$t('cancel'),
          currentIndex: Math.max(0, this.menus.indexOf(this.dataSource)),
          selectedIndex: Math.max(0, this.menus.indexOf(this.dataSource)),
          forceUpdate: true,
          actions: this.menus
        })
          .then((data) => {
            this.rotateImage = !this.rotateImage
            const result = {
              ...data,
              id: this.dataSource.id,
              isEmpty: this.isEmpty
            }
            this.chooseName = data.name
            this.$emit('onSelectChange', result)
          })
          .catch((data) => {
            this.rotateImage = !this.rotateImage
          })
      }
    },
    // onvalueChange (event) {
    //   const val = event && event.target.value
    //   this.value = this.filterContent(val, false)
    //   if (this.showRemarks) {
    //     const halfLength = this.chooseName !== this.$t('regionShort.OTHER')
    //       ? this.chooseName.length
    //       : 0
    //     const code = this.chooseName !== this.$t('regionShort.OTHER')
    //       ? this.chooseName + this.value
    //       : this.value
    //     if (code.length >= this.dataSource.maxRegionCode) {
    //       this.value = this.value.slice(0, this.dataSource.maxRegionCode - halfLength)
    //     }
    //   } else {
    //     if (this.value.length >= this.dataSource.maxTelephone) {
    //       this.value = this.value.slice(0, this.dataSource.maxTelephone)
    //     }
    //   }
    // },
    judgeEmpty (val) {
      return val === 'N/A' || val === '--' || !val
    },
    clearInput () {
      this.chooseName = this.$t('selectText')
      this.showRemarks = false
      this.value = ''
      this.telephone = ''
    },
    closePickerMask () {
      closePickerMask()
      this.rotateImage = false
    },
    closeSheetMask () {
      closeSheetMask()
      this.rotateImage = false
    }
  }
}
</script>

<style scoped lang="scss">
.selectBox-wrapper {
  box-sizing: border-box;
  width: 100%;
  margin-top: 15px;
  overflow: hidden;
}
.selectBox-wrapper ~ .selectBox-wrapper {
  margin-top: 24px;
}
.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  font-family: $common-style-font-Family;
  letter-spacing: 0;
  .title {
    color: $color-stage5;
  }
  .clear {
    padding: 5px;
    color: $color-primary;
  }
}
.content-block {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 4px;
  color: $color-stage4;
  font-size: 16px;
  font-family: $common-style-font-Family;
  letter-spacing: 0;
  .region-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 9px;
    color: $color-primary;
    @include border-bottom-customize(0, $color-bg-gray);
    .region-code {
      width: 100%;
    }
  }
  .input-wrapper {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    margin-left: 15px;
    padding-bottom: 9px;
    @include border-bottom-customize(0, $color-bg-gray);
  }
}
.telinput {
  width: 100%;
  color: $color-text;
  font-size: 16px;
  font-family: $common-style-font-Family;
  letter-spacing: 0;
}
.img-wrapper {
  width: 24px;
  height: 24px;
}
.clear-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.clearimg {
  width: 14px;
  height: 14px;
}
.telephone-remarks {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 29px;
  padding-bottom: 9px;
  @include border-bottom-customize(0, $color-bg-gray);
}
.tint {
  opacity: 0.3;
}
.event-none {
  pointer-events: none;
}
.hidden {
  visibility: hidden;
}
.rotate-image {
  transform: rotate(180deg);
  transition: all 0.3s ease;
}
.restore-image {
  transform: rotate(0);
  transition: all 0.3s ease;
}
</style>
